/**
 * Google Analytics 4 Service
 * Handles all GA4 tracking for the application
 */
import ReactGA from 'react-ga4';

// Get GA4 Measurement ID from environment
const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

/**
 * Initialize Google Analytics
 */
export const initGA = () => {
    if (GA_MEASUREMENT_ID) {
        ReactGA.initialize(GA_MEASUREMENT_ID);
        console.log('Google Analytics initialized with ID:', GA_MEASUREMENT_ID);
    } else {
        console.warn('Google Analytics Measurement ID not configured');
    }
};

/**
 * Track page view
 */
export const trackPageView = (path) => {
    if (GA_MEASUREMENT_ID) {
        ReactGA.send({ hitType: 'pageview', page: path });
    }
};

/**
 * Track custom event
 */
export const trackEvent = (category, action, label = '', value = 0) => {
    if (GA_MEASUREMENT_ID) {
        ReactGA.event({
            category,
            action,
            label,
            value
        });
    }
};

/**
 * Track user registration
 */
export const trackRegistration = (method = 'email') => {
    trackEvent('engagement', 'sign_up', method);
};

/**
 * Track user login
 */
export const trackLogin = (method = 'email') => {
    trackEvent('engagement', 'login', method);
};

/**
 * Track purchase/subscription
 */
export const trackPurchase = (packageName, amount) => {
    trackEvent('e-commerce', 'purchase', packageName, amount);
};

/**
 * Track consultation booking
 */
export const trackConsultationBooking = (consultationType) => {
    trackEvent('engagement', 'consultation_booking', consultationType);
};

/**
 * Track agency view
 */
export const trackAgencyView = (agencyId, agencyName) => {
    trackEvent('engagement', 'agency_view', agencyName);
};

/**
 * Track job view
 */
export const trackJobView = (jobId, jobTitle) => {
    trackEvent('engagement', 'job_view', jobTitle);
};

/**
 * Track search
 */
export const trackSearch = (searchTerm, resultCount) => {
    trackEvent('engagement', 'search', searchTerm, resultCount);
};

export default {
    initGA,
    trackPageView,
    trackEvent,
    trackRegistration,
    trackLogin,
    trackPurchase,
    trackConsultationBooking,
    trackAgencyView,
    trackJobView,
    trackSearch
};
